export default "__VITE_ASSET__vZPCX$9Q__"